import {ProductWidget} from '@/lib/TypesOpenApi';
import {SelectedProductsOptions} from './AppState';
import {DeepReadonly} from '@/lib/typings/readonly';

export const buildSelectedProducts = ({
  phone,
  battery,
  staticIp,
  streaming = [],
  additionalItems,
  points,
  internetAddons,
  ...restOfProducts
}: SelectedProductsOptions) => {
  const internetAddonsProducts =
    internetAddons?.map(addon => addon.productWidget) || [];
  return (
    [
      phone,
      battery,
      staticIp,
      ...(streaming as Array<ProductWidget>),
      ...points,
      ...additionalItems,
      ...internetAddonsProducts,
      // map more complicated cases to selected products
      ...mapToSelectedProduct(restOfProducts),
    ]
      // In general empty productId is allowed by API,
      // but in really back-end fail to process such requests
      // Will filter our empty and incorrect products
      .filter(
        product =>
          product &&
          typeof product.productId !== 'undefined' &&
          product.productId !== null,
      )
  );
};
export function* mapToSelectedProduct({
  internet,
}: Omit<
  SelectedProductsOptions,
  'phone' | 'battery' | 'streaming' | 'additionalItems' | 'points' | 'staticIp'
>): Generator<DeepReadonly<ProductWidget>, any, any> {
  if (internet)
    yield {
      ...internet,
    } as ProductWidget;
}
